<div class="invalid-feedback">{{ text | translate }}</div>
